export function withZipExtension(fileName, fallback = "archive.zip") {
  const name = String(fileName || fallback).trim() || fallback;
  return name.toLowerCase().endsWith(".zip") ? name : `${name}.zip`;
}

export function titleCaseZipName(fileName) {
  const name = withZipExtension(fileName);
  const stem = name.replace(/\.zip$/i, "");
  const titledStem = stem
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return `${titledStem || "Archive"}.zip`;
}

export function normalizeZipBase64(raw) {
  let s = String(raw ?? "").trim().replace(/\s/g, "");
  if (/^data:application\/zip/i.test(s) || /^data:application\/x-zip-compressed/i.test(s)) {
    const comma = s.indexOf(",");
    if (comma !== -1) s = s.slice(comma + 1);
  }
  return s;
}

export function base64ZipToBlob(base64) {
  const clean = normalizeZipBase64(base64);
  if (!clean) throw new Error("Empty ZIP payload");
  const binary = atob(clean);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: "application/zip" });
}

/** Raw ZIP bytes for parsing (e.g. fflate preview). */
export function base64ZipToUint8Array(base64) {
  const clean = normalizeZipBase64(base64);
  if (!clean) throw new Error("Empty ZIP payload");
  const binary = atob(clean);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function downloadBase64Zip(base64, fileName) {
  const blob = base64ZipToBlob(base64);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = titleCaseZipName(fileName);
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
